/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rowrequestphonehint3Inputs */

const en_rowrequestphonehint3 = /** @type {(inputs: Rowrequestphonehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can also accept requests on your phone.`)
};

const de_rowrequestphonehint3 = /** @type {(inputs: Rowrequestphonehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen nimmst du auch am Handy an.`)
};

/**
* | output |
* | --- |
* | "You can also accept requests on your phone." |
*
* @param {Rowrequestphonehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rowrequestphonehint3 = /** @type {((inputs?: Rowrequestphonehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rowrequestphonehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rowrequestphonehint3(inputs)
	return de_rowrequestphonehint3(inputs)
});
export { rowrequestphonehint3 as "rowRequestPhoneHint" }